document.addEventListener("DOMContentLoaded", function () {
    let interval = setInterval(() => {
        let cartBody = document.querySelector(".upcart-cart-body");

        if (cartBody) {
            clearInterval(interval);

            let reviewsDiv = document.createElement("div");
            reviewsDiv.innerHTML = `<style>
                .reviews-section {
                    max-width: 500px;
                    font-family: 'Termina', 'Sofia Pro', sans-serif !important;
                    padding: 0px 20px;
                }
                .reviews-title {
                    font-size: 15px;
                    color: #333;
                    font-weight: 500;
                    margin-top: 5px;
                }
                .reviews-subtitle {
                    font-size: 12px;
                    color: #777;
                    margin-bottom: 10px;
                }
                .reviews-slider {
                    overflow: hidden;
                    width: 100%;
                    position: relative; /* Ensure arrows are inside */
                }
                .reviews-container {
                    display: flex;
                    transition: transform 0.5s ease-in-out;
                }
                .review-card {
                    flex: 0 0 100%;
                    display: flex;
                    align-items: flex-start;
                    gap: 15px;
                    background: white;
                    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
                    text-align: left;
                    min-width: 100%;
                    box-sizing: border-box;
                }
                .avatar-container {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .avatar {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background-color: #203c51;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    color: white;
                    font-size: 16px;
                    text-transform: uppercase;
                }
                .review-content-wrapper {
                    flex: 1;
                    text-align: left;
                    max-width: 100%;
                    display: flex;
                    flex-direction: column;
                }
                .review-header {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 15px;
                    font-weight: 300;
                    color: #333;
                    margin-left: 55px;
                }
                .star-rating {
                    display: flex;
                    gap: 2px;
                    font-size: 14px;
                    color: #f5b301;
                }
                .review-text {
                    color: #444;
                    font-size: 14px;
                    line-height: 1.6;
                    padding-left: 55px;
                    padding-right: 46px;
                    margin-top: 4px;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    max-width: 100%;
                    display: block;
                    flex-grow: 1;
                }
                .review-arrows {
                    position: absolute;
                    top: 30%;
                    left: 1;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    transform: translateY(-50%);
                    z-index: 10;
                    pointer-events: none;
                }
                .review-arrow {
                    border: none;
                    color: white;
                    font-size: 16px;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    cursor: pointer;
                    transition: background 0.3s ease;
                    pointer-events: all;
                }
                .review-prev {
                    position: absolute;
                }
                .review-next {
                    position: absolute;
                    right: 10px;
                }
                .review-arrow:hover {
                    background: rgba(0, 0, 0, 0.6);
                }


                /* Trusted By Section */
                .trusted-by-section {
                    font-family: 'Termina', 'Sofia Pro', sans-serif !important;
                    text-align: left;
                    overflow: hidden;
                    margin-top: 15px;
                    padding: 0px 20px;
                }
                .trusted-by-section p {
                    font-size: 15px;
                    color: #333333;
                    letter-spacing: 0.08em;
                    font-weight: 500;
                    margin-bottom: 16px;
                }
                .logos-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    overflow: hidden;
                    padding: 10px 0;
                }
                .logos-slide {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 20px;
                    animation: slide 30s linear infinite;
                    width: max-content;
                }
                @keyframes slide {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-33%); }
                }
                .logos-slide img {
                    max-height: 45px;
                    width: auto;
                    opacity: 0.7;
                    transition: all 0.3s ease;
                    filter: grayscale(1);
                    object-fit: contain;
                }
                .logos-slide img:hover {
                    opacity: 1;
                    filter: grayscale(0);
                    transform: scale(1.05);
                }
            </style>

            <div class="reviews-section">
                <div class="reviews-title"><p>Customer Reviews</p></div>
                <div class="reviews-subtitle">Trusted by 10,000+ cruisers worldwide</div>
                <div class="reviews-slider">
                    <div class="reviews-container">
                        <div class="review-card">
                            <div class="review-content-wrapper">
                                <div class="review-header">Carolyn M. <div class="star-rating">★★★★★</div></div>
                                <div class="review-text">The map was accurate to the route taken and even showed the miles travelled.</div>
                            </div>
                        </div>
                        <div class="review-card">
                            <div class="review-content-wrapper">
                                <div class="review-header">Vicki <div class="star-rating">★★★★★</div></div>
                                <div class="review-text">Very happy with the quality of the map including the framing. Map arrived quickly and safely too.🙂</div>
                            </div>
                        </div>
                        <div class="review-card">
                            <div class="review-content-wrapper">
                                <div class="review-header">L.G <div class="star-rating">★★★★★</div></div>
                                <div class="review-text">Second to none customer service, fast delivery and faultless product. What more could you want?!</div>
                            </div>
                        </div>
                    </div>
                    <!-- Arrows placed INSIDE the reviews-slider -->
                    <div class="review-arrows">
                        <button class="review-arrow review-prev">&#10094;</button>
                        <button class="review-arrow review-next">&#10095;</button>
                    </div>
                </div>
            </div>
            <!-- Trusted By Section -->
            <div class="trusted-by-section">
                <p>In partnership with</p>
                <div class="logos-container">
                    <div class="logos-slide">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/4_ceb086cf-faf4-4b37-bbae-5bbc7c19bf8a.png?v=1740592715" alt="P&O">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/7_4e4e0c30-6469-4e11-8847-657c94c7ca55.png?v=1740592715" alt="Ambassador">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/2_f0c9738d-0c37-4f63-aebf-2325a97271d2.png?v=1740592715" alt="Hurtigruten">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/6_23e79594-b2e7-4b33-a564-b315df679d3f.png?v=1740592715" alt="P&O UK">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/3_a91cb943-dc8c-4292-88c8-a61b6e078064.png?v=1740592715" alt="Cunard">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/5_ffec1c64-d942-46d3-b54f-e8552bdabb6c.png?v=1741079475" alt="Marella">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/4_ceb086cf-faf4-4b37-bbae-5bbc7c19bf8a.png?v=1740592715" alt="P&O">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/7_4e4e0c30-6469-4e11-8847-657c94c7ca55.png?v=1740592715" alt="Ambassador">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/2_f0c9738d-0c37-4f63-aebf-2325a97271d2.png?v=1740592715" alt="Hurtigruten">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/6_23e79594-b2e7-4b33-a564-b315df679d3f.png?v=1740592715" alt="P&O UK">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/3_a91cb943-dc8c-4292-88c8-a61b6e078064.png?v=1740592715" alt="Cunard">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/5_ffec1c64-d942-46d3-b54f-e8552bdabb6c.png?v=1741079475" alt="Marella">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/4_ceb086cf-faf4-4b37-bbae-5bbc7c19bf8a.png?v=1740592715" alt="P&O">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/7_4e4e0c30-6469-4e11-8847-657c94c7ca55.png?v=1740592715" alt="Ambassador">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/2_f0c9738d-0c37-4f63-aebf-2325a97271d2.png?v=1740592715" alt="Hurtigruten">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/3_a91cb943-dc8c-4292-88c8-a61b6e078064.png?v=1740592715" alt="Cunard">
                        <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/5_ffec1c64-d942-46d3-b54f-e8552bdabb6c.png?v=1741079475" alt="Marella">
                    </div>
                </div>
            </div>`;

            cartBody.appendChild(reviewsDiv);

            let currentIndex = 0;
            const reviewsContainer = document.querySelector(".reviews-container");
            const totalReviews = document.querySelectorAll(".review-card").length;
            const updateSlider = () => {
                reviewsContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
            };

            document.querySelector(".review-prev").addEventListener("click", () => {
                currentIndex = (currentIndex - 1 + totalReviews) % totalReviews;
                updateSlider();
            });

            document.querySelector(".review-next").addEventListener("click", () => {
                currentIndex = (currentIndex + 1) % totalReviews;
                updateSlider();
            });
        }
    }, 1000);
}); 